import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
} from "@mui/material";

const ReportPopup = ({ open, onClose, type, data }) => {
  if (!type || !data) return null;
  console.log(data, "data of report");
  const renderLogs = (type) => {
    switch (type) {
      case "success":
        return (
          <>
            <DialogTitle>Ingestion Report</DialogTitle>
            <DialogContent dividers>
              {/* <Typography variant="body2" color="textSecondary" gutterBottom>
              Generated on: {new Date().toLocaleString()}
            </Typography> */}

              {/* File Details */}
              <Typography
                variant="h6"
                gutterBottom
                sx={{ mt: 2, fontSize: "1rem" }}
              >
                File Details
              </Typography>
              <TableContainer
                component={Paper}
                variant="outlined"
                sx={{ mb: 3 }}
              >
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ width: "50%" }}>
                        Ingested File Name
                      </TableCell>
                      <TableCell>{data.file_name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Rows Inserted</TableCell>
                      <TableCell>{data.success_logs?.rows_inserted}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Batch Info */}
              <Typography
                variant="h6"
                gutterBottom
                sx={{ mt: 2, fontSize: "1rem" }}
              >
                Batch Information
              </Typography>
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell>Batch IDs Ingested</TableCell>
                      <TableCell sx={{ color: "green" }}>
                        {data.success_logs?.batch_ids_ingested?.join(", ")}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: "50%" }}>
                        Duplicate Batches Skipped
                      </TableCell>
                      <TableCell sx={{ color: "red" }}>
                        {data.success_logs?.duplicate_batches_skipped?.join(
                          ", "
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ width: "50%" }}>
                        Duplicate Batches Updated
                      </TableCell>
                      <TableCell sx={{ color: "gray" }}>
                        {data.success_logs?.duplicate_batches_updated?.join(
                          ", "
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>

            <DialogActions>
              <Button onClick={onClose} variant="contained">
                Close
              </Button>
            </DialogActions>
          </>
        );
      case "error":
        return (
          <>
            <DialogTitle>
              {data?.file_name?.split(".")[0]}: Error Logs
            </DialogTitle>
            {/* <DialogContent dividers sx={{minHeight:'190px'}}>
              
            </DialogContent> */}
            <DialogContent dividers >
              {data?.summary && <TableContainer component={Paper} variant="outlined" sx={{marginBottom:'5px'}}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <strong>Type</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Count</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {data?.summary && Object.entries(data?.summary).map(([key, value]) => (
                      <TableRow key={key}>
                        <TableCell sx={{ textTransform: "capitalize" }}>
                          {key.replace(/_/g, " ")}
                        </TableCell>
                        <TableCell align="center">{value}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>}
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell>S.No</TableCell>
                      <TableCell>Batch ID</TableCell>
                      <TableCell>Sheet</TableCell>
                      <TableCell>Row</TableCell>
                      <TableCell>Column</TableCell>
                      <TableCell>Error Type</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>Value</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.errors?.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell>{++i}</TableCell>
                        <TableCell>{row.batch_id}</TableCell>
                        <TableCell>{row.sheet}</TableCell>
                        <TableCell>{row.row}</TableCell>
                        <TableCell>{row.column}</TableCell>
                        <TableCell>{row.error_type}</TableCell>
                        <TableCell>{row.description}</TableCell>
                        <TableCell>{row.got_value}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} variant="contained">
                Close
              </Button>
            </DialogActions>
          </>
        );
      case "filelogs":
        return (
          <>
            <DialogTitle>File logs</DialogTitle>
            <DialogContent dividers></DialogContent>{" "}
            <DialogContent dividers>
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell>File Name</TableCell>
                      <TableCell>Error</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{data.file_name}</TableCell>
                      <TableCell>{data.file_logs}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} variant="contained">
                Close
              </Button>
            </DialogActions>
          </>
        );
      default:
        return null;
    }
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      {renderLogs(type)}
    </Dialog>
  );
};

export default ReportPopup;
